import React, { useEffect, useState } from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getOpenSetup
  // OPEN_SETUP_ACTIONS
} from 'actions/protocols/opensetup';
import {
  getProtFunding, setSelectedFundingId, setSelectedFundingIndex, PRT_FUNDING_ACTIONS, saveFunding
} from 'actions/protocols/funding';
import {
  createLoadingSelector,
  createErrorMessageSelector,
  ProtocolIdSelector,
  ProtocolNumSelector,
  lSelectorGetProtDetails,
  eSelectorGetProtDetails
} from 'selectors';
import { RenderControl, RenderElement } from 'components/RenderHelpers';
import _ from 'lodash';
import { httpStatusEnum } from 'appconstants';
import { openSnackbar } from 'helpers/Notifier';
import { withAppContext } from '@ctsu/loader';
import { bindLogger } from 'helpers/BindLogger';
import { Grid } from '@material-ui/core';
import { CanUserAccessFunding } from 'appconstants/Permission';
import { FundingDetails, FundingInfo } from './components';


const loadingSelector = createLoadingSelector([
  PRT_FUNDING_ACTIONS.GET_PROT_FUNDINGS
  // OPEN_SETUP_ACTIONS.GET_OPENSETUP
]);
const errorSelector = createErrorMessageSelector([
  PRT_FUNDING_ACTIONS.GET_PROT_FUNDINGS
  // OPEN_SETUP_ACTIONS.GET_OPENSETUP
]);


const FundingComp = props => {
  const {
    protocolNumber,
    protocolId,
    context,
    fundingInfo,
    onGetPrtFunding,
    saveFundingInfo,
    openData,
    regSteps,
    setRegSteps,
    onGetOpenSetupData,
    isLoadingPrtDetails,
    iserrorPrtDetails
  } = props;

  const { fundings } = fundingInfo;
  const [fundingData, setFundings] = useState([]);
  const [fundingInd, setIndex] = useState({ highlightRow: 0 });

  const onLoad = (response) => {
    setFundings(response.data);
    setIndex({highlightRow: 0});
  }

  useEffect(() => {
    if (!_.isEmpty(protocolNumber)) {
      bindLogger(onGetOpenSetupData, context)(protocolNumber);
    }
  }, [protocolNumber, onGetOpenSetupData, context]);

  useEffect(() => {
    if (!_.isEmpty(protocolNumber)) {
      bindLogger(onGetPrtFunding, context)(protocolNumber);
    }
  }, [protocolNumber, onGetPrtFunding, context]);

  useEffect(() => {
    if (!_.isEmpty(protocolNumber) && !_.isEmpty(openData)) {
      setRegSteps(
        _.reduce(openData.protocolLogistics, (acc, item) => {
          if (item.isProcessedInFm === true) {
            acc.push({
              step: `Step : ${item.step}`,
              description: item.description
            });
          }
          return acc;
        }, [])
      );
    }
  }, [openData, setRegSteps, protocolNumber]);

  return (
    <RenderControl
      isLoading={isLoadingPrtDetails}
      iserror={iserrorPrtDetails}
      compName="Funding Information"
      permission={CanUserAccessFunding()}
    >
      <Grid container justify="center" spacing={4}>
        <Grid item xs={6}>
          <RenderElement access>
            <FundingInfo
              protocolId={protocolId}
              onSetIndex={setIndex}
              data={fundings.data}
              regSteps={regSteps}
              fundingIndex={fundingInd}
              saveFundingInfo={saveFundingInfo}
              onDataLoad={onLoad}
            />
          </RenderElement>
        </Grid>
        <Grid item xs={6}>
          <div className="related-border-left related-border-active related-border-top2">
            <RenderElement access>
              <FundingDetails
                data={fundingData}
                fundingIndex={fundingInd.highlightRow}
              />
            </RenderElement>
          </div>
        </Grid>
      </Grid>
    </RenderControl>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({
    fundingInfo: state.fundings,
    openData: state.openData.openData,
    protocolId: ProtocolIdSelector(state),
    protocolNumber: ProtocolNumSelector(state),
    isLoading: loadingSelector(state),
    iserror: errorSelector(state),
    isLoadingPrtDetails: lSelectorGetProtDetails(state),
    iserrorPrtDetails: eSelectorGetProtDetails(state)
  }),
  dispatch => bindActionCreators(
    {
      onGetOpenSetupData: getOpenSetup,
      onGetPrtFunding: getProtFunding,
      onSetSelectedFundingIndex: setSelectedFundingIndex,
      onSetSelectedFundingId: setSelectedFundingId,
      onSaveFunding: saveFunding
    },
    dispatch
  )
);

const FundingContainer = compose(
  withConnectState,
  withAppContext,
  withState('regSteps', 'setRegSteps', []),
  withHandlers({
    saveFundingInfo: (props) => (postBody) => {
      const {
        onSaveFunding, context, protocolId
      } = props;
      return bindLogger(onSaveFunding, context)(protocolId,
        { ...postBody, prtId: protocolId }).subscribe(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          openSnackbar({
            message: 'Funding information saved successfully.', // SAVE_FUNDING_SUCCESS,
            variant: 'success',
            name: 'funding'
          });
        }
      });
    }
  })
)(FundingComp);

export default FundingContainer;
